"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const SixteenNineIframe = ({ src, title, id, containerClass, testId, allowFullScreen = true }) => {
    const containerRef = (0, react_1.useRef)(null);
    const [containerHeight, setContainerHeight] = (0, react_1.useState)();
    (0, react_1.useLayoutEffect)(() => {
        const handleContainerHeight = (0, debounce_1.default)(() => {
            if (containerRef.current) {
                const containerWidth = containerRef.current.clientWidth;
                setContainerHeight(containerWidth * (9 / 16));
            }
        }, 200);
        handleContainerHeight();
        window.addEventListener('resize', handleContainerHeight);
        return () => {
            window.removeEventListener('resize', handleContainerHeight);
        };
    }, []);
    return (react_1.default.createElement("div", { className: containerClass, "data-testid": testId, ref: containerRef, style: {
            height: typeof containerHeight === 'number' ? `${containerHeight}px` : 'auto'
        } },
        react_1.default.createElement("iframe", { id: id, title: title, src: src, width: "100%", height: "100%", allowFullScreen: allowFullScreen, frameBorder: "0" })));
};
exports.default = SixteenNineIframe;
//# sourceMappingURL=sixteen-nine-iframe.js.map